import toast from 'react-hot-toast';
import { IResponse } from '../../../libs/requester/IResponse';
import { requester } from '../../../libs/requester/requester-axios';
import { pizzaWayAPI } from '../../pizzaWayAPI';
import { IBadgesResponse, IBadgesParams } from '../repository/IBadge';

const badgeAPI = pizzaWayAPI.injectEndpoints({
    endpoints: (builder) => ({
        getBadges: builder.query<IBadgesResponse, IBadgesParams>({
            async queryFn(params, { dispatch }) {
                try {
                    const { data, isError, message }: any = await requester.get('/api/badge/admin/list', params);
                    if (isError) {
                        toast.error(message);
                        throw new Error(message);
                    };
                    return { data };
                } catch (e) {
                    throw e;
                }
            },
            providesTags: ['Badge']
        }),
    }),
    overrideExisting: false,
});

export const { useGetBadgesQuery } = badgeAPI;